import getStrapiCollections from '../integration/strapi.client';
import { STRAPI_ACTION_MODALS } from './constants';
import logger from './logging.client';

/**
 * @name getStrapiModalInfo
 * @description Fetches data from the Strapi Collection API
 * @param {string} modalID Modal Id of required collection type
 * @returns {Promise<void>} Promise and sets the state clientSideStrapi when resolved
 */
const getStrapiModalInfo = async modalID => {
  try {
    const data = await getStrapiCollections(STRAPI_ACTION_MODALS, modalID);
    return data;
  } catch (error) {
    logger.log('error', 'Unable to fetch strapi modals', error);
    return error;
  }
};

export default getStrapiModalInfo;
